import { type FC, type ReactNode } from "react";

import { faSparkles } from "@fortawesome/pro-duotone-svg-icons/faSparkles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// A violet-outlined chip over the message box that asks the assistant, with
// its sparkle. `note` says why it's off, on hover and to a screen reader.
export const AskChip: FC<{
  children: ReactNode;
  onClick(): void;
  disabled?: boolean;
  note?: string;
}> = ({ children, onClick, disabled, note }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    title={note}
    aria-description={note}
    className="inline-flex h-7 items-center gap-1.5 rounded-full border border-violet-200 bg-white px-3 text-[12px] font-medium text-violet-700 outline-none focus-visible:ring-4 focus-visible:ring-violet-200 enabled:hover:bg-violet-50 disabled:cursor-default disabled:opacity-45"
  >
    <FontAwesomeIcon icon={faSparkles} className="text-[11px]" />
    {children}
  </button>
);
